module.exports = __webpack_public_path__ + "static/mountain-ee0659276c479175610795d9a8e2b0c0.jpg";